export default __webpack_public_path__ + "static/media/idea.7ce8af31.jpg";